// src/pages/AppointmentReasonsPage.jsx
import MastersCrudPage from "../components/MastersCrudPage";
import {
  listReasons,
  createReason,
  updateReason,
  deleteReason,
} from "../api/mastersApi";

export default function AppointmentReasonsPage() {
  return (
    <MastersCrudPage
      title="Appointment Reasons"
      fetchList={listReasons}
      createItem={createReason}
      updateItem={updateReason}
      deleteItem={deleteReason}
      columns={[
        { key: "id", label: "ID" },
        { key: "code", label: "Código" },
        { key: "name", label: "Nombre" },
      ]}
      initialForm={() => ({ code: "", name: "" })}
      renderForm={({ form, setForm }) => (
        <>
          <div>
            <label className="block text-xs text-gray-400">Código</label>
            <input value={form.code} onChange={e => setForm({...form, code: e.target.value})} className="w-full p-2 rounded bg-[#020817] border border-gray-700" />
          </div>
          <div>
            <label className="block text-xs text-gray-400">Nombre</label>
            <input value={form.name} onChange={e => setForm({...form, name: e.target.value})} className="w-full p-2 rounded bg-[#020817] border border-gray-700" />
          </div>
        </>
      )}
    />
  );
}
